import { render, staticRenderFns } from "./Foto.vue?vue&type=template&id=2f42f1d8&scoped=true&"
import script from "./Foto.vue?vue&type=script&lang=js&"
export * from "./Foto.vue?vue&type=script&lang=js&"
import style0 from "./Foto.vue?vue&type=style&index=0&id=2f42f1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f42f1d8",
  null
  
)

export default component.exports